/**
 * Pen tool cursor data URIs.
 * Using inline SVG data URIs instead of external files avoids browser SVG cursor
 * loading failures (MIME type, file serving, or stroke-only rendering issues).
 * All cursors use the Lucide PenTool icon paths with a white halo for visibility.
 * Hotspot is (2, 2) — near the pen tip at the top-left of the 24×24 icon.
 */

function makeCursor(svgContent: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="24" viewBox="0 0 38 24">${svgContent}</svg>`
  const b64 = btoa(unescape(encodeURIComponent(svg)))

  return `url("data:image/svg+xml;base64,${b64}") 2 2, default`
}

const HALO = [
  `<path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z" fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>`,
  `<path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18" fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>`,
  `<path d="m2.3 2.3 7.286 7.286" fill="none" stroke="white" stroke-width="4" stroke-linecap="round"/>`,
  `<circle cx="11" cy="11" r="2" fill="white" stroke="white" stroke-width="3"/>`,
].join('')

const ICON = [
  `<path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
  `<path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
  `<path d="m2.3 2.3 7.286 7.286" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round"/>`,
  `<circle cx="11" cy="11" r="2" fill="none" stroke="#111" stroke-width="2"/>`,
].join('')

const BADGE_PLUS = [
  `<circle cx="30" cy="8" r="6" fill="#111"/>`,
  `<line x1="30" y1="4.5" x2="30" y2="11.5" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
  `<line x1="26.5" y1="8" x2="33.5" y2="8" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
].join('')

const BADGE_MINUS = [
  `<circle cx="30" cy="8" r="6" fill="#111"/>`,
  `<line x1="26.5" y1="8" x2="33.5" y2="8" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
].join('')

export const PEN_TOOL_CURSOR = makeCursor(`${HALO}${ICON}`)
export const PEN_PLUS_CURSOR = makeCursor(`${HALO}${ICON}${BADGE_PLUS}`)
export const PEN_MINUS_CURSOR = makeCursor(`${HALO}${ICON}${BADGE_MINUS}`)
